/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { pipelineStageMove } from '../../axios/pipelineStageMove'
import type {
	PipelineStageMoveError,
	PipelineStageMovePathParams,
	PipelineStageMoveRequest,
	PipelineStageMoveResponse,
} from '../../types/PipelineStageMove'

export const pipelineStageMoveMutationKey = () => [{ url: '/campaigns/:campaign/pipeline-stages/candidates' }] as const

export type PipelineStageMoveMutationKey = ReturnType<typeof pipelineStageMoveMutationKey>

export type PipelineStageMoveVariables = {
	campaign: PipelineStageMovePathParams['campaign']
	data: PipelineStageMoveRequest
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/PipelineStageController.php PipelineStageController::move */
export function usePipelineStageMove<TContext = unknown>(
	options?: UseMutationOptions<
		PipelineStageMoveResponse,
		AxiosError<PipelineStageMoveError>,
		PipelineStageMoveVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: pipelineStageMoveMutationKey(),
		mutationFn: ({ campaign, data }: PipelineStageMoveVariables) =>
			pipelineStageMove(campaign, data, config).then(res => res.data),
		...options,
	})
}
